import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}